import React, { Component } from 'react'
import { Link } from 'react-router-dom';

// components
import Sidemenu from '../../../components/sidemenu'
import Header from '../../../components/dashHeader'

//css 
import '../../styles/dashboard/Home.css'

// assets
import Arrow from '../../../assets/icons/forward.svg'
import Back from '../../../assets/svg/back-arrow.svg'
import Check from '../../../assets/svg/other/check-sm.svg'


export default class Home3PBuyAddress extends Component {


    render() {

        const currentPage = "Home";

        return (
            <div>
                <Sidemenu currentPage={currentPage} />
                <Header />


                <section className="home">
                    <div className="home-container">
                        <div className="home-buy-content">
                            <Link to="/dashboard/homep3pbuy">
                            <img src={Back} className="w-backarrow" alt="back" />
                            </Link>
                            <h1> Enter BTC Wallet Address </h1>
                            <div className="home-nav">
                                <Link to="/dashboard/home" className="right-e"><p className="ash"> Home </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <Link to="/dashboard/home3pbuy" className="right-e"><p className="ash"> Third Party Buy </p> </Link>
                                <img className="right-e" src={Arrow}alt="" />
                                <p><span className="bold"> BTC Wallet Address</span></p>
                            </div>
                            <div className="p3buy-content">
                                <p className="p3buy-title both-m0">Our provider will send money to this address after you complete payment</p>
                                <div className="p2p-inputs">
                                    <input type="text" placeholder="Enter BTC receipt Adress"/>
                                </div>
                                <p className="p3buy-check"><span className="right-m2"><img src={Check} alt="check"/></span>I agree with Terms of Use, Privacy Policy  and AML/KYC</p>
                                <button className="p2p-submit" type="submit">Go to payment</button>
                            </div>
                            
                        </div>
                    </div>
                </section>
            </div>
        )
    }
}
